// import LandingPage from './components/pages/landing'
import Login from './components/pages/auth/loginComponent'
import Dashboard from './components/pages/dashboard/dashboardComponent'
import Home from './components/pages/home/homeComponent'
import Os from './components/pages/os/osComponent'
import osCreate from './components/pages/os/create'
import osEdit from './components/pages/os/edit'
import osView from './components/pages/os/view'
import Products from './components/pages/products/productsComponent'
import ProductsView from './components/pages/products/view'
import ProductsEdit from './components/pages/products/edit'
import Clients from './components/pages/clients/clientsComponent'
import ClientsView from './components/pages/clients/view'
import ClientsEdit from './components/pages/clients/edit'
import Services from './components/pages/services/servicesComponent'
import Receipts from './components/pages/receipts/receiptsComponent'
import Logout from './components/pages/auth/logoutComponent'
import Register from './components/pages/auth/registerComponent'

const routes = [

  {
    path: '/',
    name: 'landing',
    redirect: "/dashboard",
    component: Home,
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    children: [
      {
        path: '/dashboard',
        name: 'dashboard',
        component: Dashboard,
        meta: {
          requiresAuth: true
        }
      },

      // PRODUTOS

{
        path: '/products',
        component: Products,
        children: [{
          path: '/',
          component: Products,
          name: 'products',
          meta: {
            requiresAuth: true,
            title: 'Tabela de produtos',
            mobileTitle: 'Produtos',
            description: 'Versão Beta',

          },
        }]
      },
      {
        path: '/products/:id',
        name: 'ProductsView',
        component: ProductsView,
        meta: {
          title: 'Visualização de produto',
          description: 'Versão Beta',
          requiresAuth: true
        }
      },
      {
        path: '/products/edit/:id',
        name: 'ProductsEdit',
        component: ProductsEdit,
        meta: {
          title: 'Edição de Produto',
          description: 'Versão Beta',
          requiresAuth: true
        }
      },

      // CLIENTES

      {
        path: '/clients',
        component: Clients,
        children: [{
          path: '/',
          component: Clients,
          name: 'clients',
          meta: {
            requiresAuth: true,
            title: 'Tabela de Clientes',
            mobileTitle: 'Clientes',
            description: 'Versão Beta',

          },
        }]
      },
      {
        path: '/clients/:id',
        name: 'clientsView',
        component: ClientsView,
        meta: {
          title: 'Visualização de Cliente',
          description: 'Versão Beta',
          requiresAuth: true
        }
      },
      {
        path: '/clients/edit/:id',
        name: 'ClientsEdit',
        component: ClientsEdit,
        meta: {
          title: 'Edição de Cliente',
          description: 'Versão Beta',
          requiresAuth: true
        }
      },

      // SERVIÇOS

      {
        path: '/services',
        name: 'services',
        component: Services,
        meta: {
          title: 'Tabela de Serviços',
          mobileTitle: 'Serviços',
          description: 'Versão Beta',
          requiresAuth: true
        }
      },

      // RECIBOS

      {
        path: '/receipts',
        name: 'receipts',
        component: Receipts,
        meta: {
          requiresAuth: true
        }
      },

      // ORDEM DE SERVIÇO

      {
        path: '/os',
        component: Os,
        children: [{
          path: '/',
          component: Os,
          name: 'os',
          meta: {
            requiresAuth: true,
            title: 'Tabela de Ordens de Serviço',
            mobileTitle: 'Os',
            description: 'Versão Beta',
          },
        }]
      },
      {
        path: '/os/create',
        name: 'osCreate',
        component: osCreate,
        meta: {
          title: 'Cadastrar Ordem de Serviço',
          description: 'Versão Beta',
          requiresAuth: true
        }
      },
      {
        path: '/os/:id',
        name: 'osView',
        component: osView,
        meta: {
          title: 'Visualização de Os',
          description: 'Versão Beta',
          requiresAuth: true
        }
      },
      {
        path: '/os/edit/:id',
        name: 'osEdit',
        component: osEdit,
        meta: {
          title: 'Edição de Cliente',
          description: 'Versão Beta',
          requiresAuth: true
        }
      },


      {
        path: '/logout',
        name: 'logout',
        component: Logout,
        meta: {
          requiresAuth: true
        }
      }
    ]
  },

  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      requiresVisitor: true,
    }
  },
  {
    path: '/register',
    name: 'register',
    component: Register,
    meta: {
      requiresVisitor: true,
    }
  },


]

export default routes